import Covid19Constants from '../../../common/Covid19Constants';

export default {
  caSubmitCount: 0,
  receiveUpdates: true,
  [Covid19Constants.signup.propertyName]: false
};



/** WEBPACK FOOTER **
 ** ./src/components/checkout/Checkout/CheckoutFormInitialValues.js
 **/